import $ from 'jquery';
import moment from 'moment';
import _ from 'lodash';

import storeProvider from '../storeProvider';

import { addFlashMessage } from './FlashMessages';
import { getIntl } from './IntlInstance';

export const defaultLogo = '/images/stockpress-brand-mark.png';

export const getStore = () => (storeProvider.getStore());

export const getState = () => {
  const store = getStore();
  if (store) {
    return store.getState();
  }

  return false;
};

export const getAppUrl = () => {
  let domain = window.location.host;

  if (process.env.MIX_NGROK_DEV_ENABLED === 'true') {
    return `https://${process.env.MIX_NGROK_DEV_SUBDOMAIN}.${process.env.MIX_NGROK_DEV_APP_DOMAIN}`;
  }

  if (window.sp.mini && !window.sp.is_espn && domain !== 'cc.stockpress.xyz') {
    domain = `api.${process.env.MIX_APP_DOMAIN}`;
    if (process.env.MIX_ENV === 'local') {
      domain = `${domain}:4443`;
    }
  }

  if (domain === process.env.MIX_APP_DOMAIN) {
    domain = `api.${domain}`;
  }

  let urlProtocol = window.location.protocol;
  if (window.sp.mini) {
    urlProtocol = 'https:';
  }

  return `${urlProtocol}//${domain}`;
};

export const getDomain = (url) => (
  url ? (new URL(url)).hostname : null
);

export const getSubdomain = (domain = window.location.origin) => (
  domain ? getDomain(domain).split('.').slice(0, -2).join('.') : null
);

export const getAPIUrl = path => (
  `${getAppUrl()}${process.env.MIX_API_PATH}${path}`
);

export const getLogoUrl = () => (
  `/logo/full/?theme=${window.sp?.logoColor || 'dark'}`
);

export const isArchive = (pathname = window.location.pathname) => {
  const urlParams = pathname.replace(/^[/]+|[/]+$/g, '').split('/');
  return urlParams.length > 0 && urlParams[0] === 'archive';
};

export const isArchiveUrl = (url) => {
  const urlParams = url.replace(/^[/]+|[/]+$/g, '').split('/');
  return urlParams.length > 0 && urlParams[0] === 'archive';
};

export const isTrash = (pathname = window.location.pathname) => {
  const urlParams = pathname.replace(/^[/]+|[/]+$/g, '').split('/');
  return urlParams.length > 0 && urlParams[0] === 'trash';
};

export const isFavorites = (pathname = window.location.pathname) => {
  const urlParams = pathname.replace(/^[/]+|[/]+$/g, '').split('/');
  return urlParams.length > 0 && urlParams[0] === 'favorites';
};

export const isShare = (pathname = window.location.pathname) => (
  pathname.indexOf('/shares/') === 0
);

export const isCustomPage = (pathname = window.location.pathname) => (
  pathname.indexOf('/pages/') === 0
);

export const isSearchResults = () => (
  window.location.pathname === '/results'
);

export const isMini = () => (
  getState().Mini.config !== null
);

export const isMiniAdobeIntegration = () => {
  const state = getState();
  return state.Mini.config !== null && state.Mini.config.integrationId.startsWith('adobe-');
};

export const isMiniFigmaIntegration = () => {
  const state = getState();
  return state.Mini.config !== null && state.Mini.config.integrationId === 'figma';
};

export const cleanLoginParams = (searchParams) => {
  const params = new URLSearchParams(searchParams);
  params.delete('auth_token');
  params.delete('login_token');
  params.delete('jwt_token');
  if (params.toString()) {
    return `?${params.toString()}`;
  }
  return '';
};

export const cleanRedirectUrl = (url) => {
  if (!url) {
    return '';
  }

  const urlParts = url.split('?');
  const params = new URLSearchParams(urlParts[1]);
  params.delete('auth_token');
  params.delete('login_token');
  params.delete('jwt_token');
  return `${urlParts[0]}?${params.toString()}`;
};

export const resizeSplitContentContainer = () => {
  let height = window.innerHeight;
  if ($('.toolbar').height()) {
    height -= $('.toolbar').height();
  }
  if ($('.actionbar.active').height()) {
    height -= $('.actionbar.active').height();
  }
  if ($('.archive-header').height()) {
    $('.main-content.split-content').css('padding-bottom', $('.archive-header').height() + 20);
  }
  $('.main-content.split-content').height(height);

  const sidebarHeight = $(window).height() - 79 - $('.sidebar .sidebar-header').height();
  $('.sidebar .nav-tab-content').height(sidebarHeight);
};

export const resizeTrialInfo = () => {
  if (window.$('.trial-info-bar').length) {
    const trialInfoHeight = window.$('.trial-info-bar').outerHeight();
    window.$('.layout.layout-nav-side').height(`calc(100vh - ${trialInfoHeight}px)`);
    window.$('.layout.layout-nav-side .sidebar-navigation').height(`calc(100vh - ${trialInfoHeight}px)`);
    if (window.$('.layout .sidebar .sidebar-nav').is(':visible')) {
      window.$('.layout .sidebar').height(`calc(100vh - ${trialInfoHeight}px)`);
    }
    window.$('.layout .main-container').height(`calc(100vh - ${trialInfoHeight}px)`);
    if (!window.$('.layout .main-container .main-content').hasClass('.split-content')) {
      window.$('.layout .main-container .main-content').css('overflow', 'hidden auto');
    }
  }
};

export const resizeAccountUsageInfo = () => {
  if (window.$('.account-usage-info-bar').length) {
    const trialInfoHeight = window.$('.account-usage-info-bar').outerHeight();
    window.$('.layout.layout-nav-side').height(`calc(100vh - ${trialInfoHeight}px)`);
    window.$('.layout.layout-nav-side .sidebar-navigation').height(`calc(100vh - ${trialInfoHeight}px)`);
    if (window.$('.layout .sidebar .sidebar-nav').is(':visible')) {
      window.$('.layout .sidebar').height(`calc(100vh - ${trialInfoHeight}px)`);
    }
    window.$('.layout .main-container').height(`calc(100vh - ${trialInfoHeight}px)`);
    if (!window.$('.layout .main-container .main-content').hasClass('.split-content')) {
      window.$('.layout .main-container .main-content').css('overflow', 'hidden auto');
    }
  }
};

export const trialEnded = (client) => {
  if (!client || !client.in_trial) {
    return false;
  }
  return client.trial_ended || moment.utc(client.trial_ends_at).diff(moment.utc(), 'seconds') < 0;
};

export const getTrialLeftDaysCount = (client) => {
  if (!client || !client.is_in_trial || !client.trial_ends_at) return null;

  return moment.utc(client.trial_ends_at).diff(moment.utc(), 'days') + 1;
};

export const subscriptionExpired = (client) => {
  if (!client || !client.is_subscribed) {
    return false;
  }
  return client.subscription_expired || moment.utc(client.stripe_next_payment_at).diff(moment.utc(), 'seconds') < 0;
};

export const accountUsageLock = (client) => {
  if (client.usage_lock) {
    return true;
  }
  return false;
};

export const getTitleFromSummary = (summary, intl) => {
  const elements = [];

  if (summary.collections > 0) {
    elements.push(intl.formatMessage({
      defaultMessage: '{collections} {collections, plural, one {Collection} other {Collections}}',
    }, { collections: summary.collections }));
  }

  if (summary.files > 0) {
    elements.push(intl.formatMessage({
      defaultMessage: '{files} {files, plural, one {file} other {files}}',
    }, { files: summary.files }));
  }

  if (elements.length > 1) {
    const andTranslation = intl.formatMessage({
      defaultMessage: 'and',
    });
    return elements.join(` ${andTranslation} `);
  }

  return elements[0] || '';
};

export const formatCurrency = value => (
  parseFloat(value.toFixed(2)) === parseInt(value) ?
    value :
    value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
);

export const isEllipsisActive = (element) => {
  if (element && element.clientWidth < element.scrollWidth) {
    const style = element.currentStyle || window.getComputedStyle(element);
    return style.textOverflow === 'ellipsis';
  }
  return false;
};

export const downloadCSV = (data, fileName) => {
  const intl = getIntl();

  const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
  const a = document.createElement('a');
  a.href = window.URL.createObjectURL(blob);
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();

  addFlashMessage({
    type: 'success',
    text: intl.formatMessage({
      defaultMessage: 'Downloaded csv file',
    }),
  });

  return [];
};

export const getSidebarCurrentRoute = (location) => {
  if (!location || !location.pathname) return null;

  if (location.pathname === '/') return 'dashboard';
  if (location.pathname === '/files' || location.pathname === '/archive/files') return 'files';
  if (location.pathname === '/collections' || location.pathname === '/archive/collections') return 'collections';
  if (location.pathname === '/collections/my' || location.pathname === '/archive/collections/my') return 'my-collections';
  if (location.pathname === '/favorites') return 'favorites';
  if (location.pathname === '/people') return 'people';
  if (location.pathname === '/admin/pages') return 'pages';

  return null;
};

export const isSecondSidebarHiddenOnLocation = (location) => {
  const hideOnPathnames = [
    '/admin/settings',
    '/admin/pages/add',
  ];

  if (hideOnPathnames.some(path => location.pathname.startsWith(path))) return true;

  if (/^\/admin\/pages\/\d+\/edit/.test(location.pathname)) return true;

  return false;
};

export const shouldShowSecondSidebar = (location) => {
  const hiddenOnLocation = isSecondSidebarHiddenOnLocation(location);

  if (hiddenOnLocation) return false;

  return getState().App.secondSidebarOpen;
};

export const isMobile = () => (
  $(window).outerWidth() < 768
);

export const findPathToKey = (objectTree, targetKey, currentPath = '') => {
  let foundPath;

  const search = (obj, path) => {
    if (foundPath) return;

    const keys = _.keys(obj);

    // Check siblings
    _.forEach(keys, key => {
      if (String(key) === String(targetKey)) {
        foundPath = path ? `${path}.${key}` : key;
      }
    });

    if (foundPath) return;

    // Go deeper
    _.forEach(keys, key => {
      const value = obj[key];
      const newPath = path ? `${path}.${key}` : key;

      if (_.isArray(value)) {
        _.forEach(value, (item, index) => {
          if (foundPath) return false;

          if (_.isObject(item) && !_.isArray(item)) {
            search(item, `${newPath}[${index}]`);
          }

          return true;
        });
      } else if (_.isObject(value)) {
        search(value, newPath);
        if (foundPath) return false;
      }

      return !foundPath;
    });
  };

  search(objectTree, currentPath);
  return foundPath;
};

export const getBackButtonMeta = (scope) => {
  const intl = getIntl();

  const map = {
    taxonomies: {
      text: intl.formatMessage({ defaultMessage: 'Back to all Tag Categories' }),
      pathname: '/admin/settings/categories',
    },
    users: {
      text: intl.formatMessage({ defaultMessage: 'Back to all Users' }),
      pathname: '/admin/settings/users',
    },
    'custom-fields': {
      text: intl.formatMessage({ defaultMessage: 'Back to all Custom Fields' }),
      pathname: '/admin/settings/custom-fields',
    },
    teams: {
      text: intl.formatMessage({ defaultMessage: 'Back to all Teams' }),
      pathname: '/admin/settings/teams',
    },
    roles: {
      text: intl.formatMessage({ defaultMessage: 'Back to all Custom Roles' }),
      pathname: '/admin/settings/roles',
    },
    'download-requests': {
      text: intl.formatMessage({ defaultMessage: 'Back to all Download requests' }),
      pathname: '/download-requests',
    },
  };

  return map[scope];
};
